import * as api from '../resources/documents.api';
import actionTypes from './action-types';

export const fetchNewLabelStatusRequest = () => ({
  type: actionTypes.FETCH_NEW_LABEL_STATUS_REQUEST,
});

export const fetchNewLabelStatusSuccess = (status) => ({
  type: actionTypes.FETCH_NEW_LABEL_STATUS_SUCCESS,
  status,
});

export const fetchNewLabelStatusFailure = () => ({
  type: actionTypes.FETCH_NEW_LABEL_STATUS_FAILURE,
});

export const fetchNewLabelStatus = () => async (dispatch) => {
  try {
    dispatch(fetchNewLabelStatusRequest());

    const status = await api.fetchNewLabelStatus();
    dispatch(fetchNewLabelStatusSuccess(status));
  } catch (error) {
    console.error('FETCH_NEW_LABEL_STATUS', error);
    dispatch(fetchNewLabelStatusFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/documents/actions/fetch-new-label-status.actions.js